import BigNumber from 'bignumber.js';
import {
  FETCH_USER_VOLUME_24H_SUCCEED,
  FETCH_WITHDRAWAL_HISTORY_SUCCEED,
  WS_EVENT_USER_TRANSACTION,
} from '../actions/transactions/action_types';
import consts from '../../consts';
import utils from '../../common/utils';

export default (
  state = {
    withdrawalHistory: [],
    userVolume24h: {},
    totalCount: 0,
  },
  action,
) => {
  switch (action.type) {
    case FETCH_WITHDRAWAL_HISTORY_SUCCEED:
      return {
        ...state,
        withdrawalHistory: window._.isArray(action.params.data)
          ? window._.map(action.params.data, (item) => {
            item.key = item.id;
            item.amount = new BigNumber(item.amount).toString(10);
            item.fee = new BigNumber(item.fee).toString(10);
            return item;
          })
          : [],
        totalCount: action.params.totalCount || 0,
      };
    case FETCH_USER_VOLUME_24H_SUCCEED:
      return {
        ...state,
        userVolume24h: {
          ...state.userVolume24h,
          [`${action.params.data.currency}`]: action.params.data.volume24h,
        },
      };
    case WS_EVENT_USER_TRANSACTION:
      if ((state.withdrawalHistory || []).length == consts.DEFAULT_PAGE_SIZE) {
        state.withdrawalHistory.pop();
      }

      const transaction = action.data;
      transaction.amount = new BigNumber(transaction.amount).toString(10);
      transaction.fee = new BigNumber(transaction.fee).toString(10);

      console.log({
        quantity: transaction.amount,
        currency: transaction.currency,
      });
      if (transaction.type === consts.TRANSACTION_TYPE_DEPOSIT) {
        utils.showNotification(window.$t('message.transaction_deposit_title'), window.$t('message.transaction_deposit', {
          quantity: transaction.amount,
          currency: transaction.currency,
        }));
      }
      return {
        ...state,
        withdrawalHistory: [transaction, ...state.withdrawalHistory],
      };
    default:
      return {
        ...state,
      };
  }
};
